import { systemEngineEnvironment } from "services/environment/systemEngine";

export const createRole = async (roleName: string) => {
  await systemEngineEnvironment.execute(`create role "${roleName}"`);
};
